<template>
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" stroke="currentColor" stroke-width="1.45538"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path
            d="M16.1082 28.35H5.25805C3.76325 28.35 2.53906 27.1515 2.53906 25.6825V6.55943C2.53906 3.18325 5.05187 1.64979 8.13166 3.15748L13.8531 5.96666C15.0902 6.57231 16.1082 8.18309 16.1082 9.54902V28.35Z" />
        <path
            d="M28.3126 19.4069V24.2779C28.3126 27.0613 27.024 28.3499 24.2406 28.3499H16.1094V13.4277L16.715 13.5566L22.5138 14.8581L25.1297 15.438C26.8307 15.8117 28.2224 16.6879 28.2997 19.1621C28.3126 19.2394 28.3126 19.3167 28.3126 19.4069Z" />
        <path d="M7.08594 11.5977H11.5574" />
        <path d="M7.08594 16.752H11.5574" />
        <path
            d="M22.5136 14.8581V19.0075C22.5136 20.6054 21.2121 21.9069 19.6142 21.9069C18.0163 21.9069 16.7148 20.6054 16.7148 19.0075V13.5566L22.5136 14.8581Z" />
        <path
            d="M28.2976 19.1619C28.2203 20.6825 26.9575 21.9067 25.4111 21.9067C23.8132 21.9067 22.5117 20.6051 22.5117 19.0073V14.8579L25.1276 15.4378C26.8286 15.8115 28.2203 16.6877 28.2976 19.1619Z" />
    </svg>
</template>
